export function anchorScroll() {
  const links = document.querySelectorAll('a[href*="#"]');
  const navHeight = document.querySelector('.p-top-nav') ? document.querySelector('.p-top-nav').offsetHeight : 0;

  links.forEach(link => {
    link.addEventListener('click', function(event) {
      const targetId = this.hash.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        event.preventDefault();
        window.scrollTo({
          top: targetElement.offsetTop - navHeight,
          behavior: 'smooth'
        });
      }
    });
  });
}